/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string, object, bool, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import withStyles from '@material-ui/core/styles/withStyles';

import { getUserSubmittedProductFilterZipcode, getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';

import customBreakpoints from '../../../../helpers/customBreakpoints';

const styles = (theme) => ({
    buttonWrapperLink: {
        textDecoration: 'none',
        border: '2px solid rgba(0, 0, 0, 1)',
        borderRadius: '4px',
    },
    redirectButton: {
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    modalPaper: {
        padding: '12px',
        maxWidth: '320px',
        position: 'absolute',
        left: '65vw',
        top: '35%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            margin: 0,
            left: 'auto',
        },
    },
    outerDialog: {},
    infoText: {
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
        paddingBottom: '10px',
    },
    closeButton: {
        textAlign: 'right',
        cursor: 'pointer',
    },
    errorIcon: {
        color: 'red',
        width: '40px',
        height: 'auto',
    },
    iconWrapper: {
        height: '40px',
    },
});

const GraphqlProductNotAvailableModal = ({
    classes,
    location,
    userSubmittedZip,
    isOpen,
    onClose,
    deliveryAvailable,
    dataDictionary,
    hideCta,
}) => {
    let redirectLocation;
    if (location.state && location.state.fromCategoryPage) {
        if (location.state.fromCategoryPage === true) {
            redirectLocation = location.state.prevUrl;
        }
    } else {
        redirectLocation = '/bestsellingflowers';
    }

    // TODO: Firing too much
    // trackEvent({ eventCategory: 'Product Page', eventAction: 'Product Unavailable', eventLabel: productName });
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            className={classes.outerDialog}
            hideBackdrop
            classes={{
                paper: classes.modalPaper,
            }}
        >
            <Grid
                className={classes.topBar}
                container
                direction="row"
                justify="space-between"
            >
                <Grid item className={classes.iconWrapper}>
                    {' '}
                    <ErrorOutlineIcon className={classes.errorIcon} />
                </Grid>
                <Grid item className={classes.closeButton} onClick={onClose}>
                    <span>X</span>
                </Grid>
            </Grid>
            <Grid item>
                <Typography className={classes.infoText}>
                    {dataDictionary?.['We are sorry, the product you have selected is not available'] || 'We are sorry, the product you have selected is not available'}
                </Typography>
            </Grid>

            {deliveryAvailable && !hideCta && (
                <Link to={redirectLocation} className={classes.buttonWrapperLink}>
                    <Button variant="outlined" className={classes.redirectButton}>
                        {dataDictionary?.['SEE PRODUCTS FOR'] || 'SEE PRODUCTS FOR'} {userSubmittedZip}
                    </Button>
                </Link>
            )}
        </Dialog>
    );
};

const mapStateToProps = (state) => ({
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    dataDictionary: getDataDictionary(state),
});

GraphqlProductNotAvailableModal.propTypes = {
    userSubmittedZip: string.isRequired,
    isOpen: bool.isRequired,
    deliveryAvailable: bool.isRequired,
    location: object.isRequired,
    onClose: func.isRequired,
    classes: object.isRequired,
    dataDictionary: object,
    hideCta: bool.isRequired,
};

GraphqlProductNotAvailableModal.defaultProps = {
    dataDictionary: {},
};
export default withRouter(
    connect(
        mapStateToProps,
        null,
    )(withStyles(styles)(GraphqlProductNotAvailableModal)),
);
